export default menuMobile => {
    // console.log('menuMobile');
    const ww = window.innerWidth;
    const menuItemsOpenSubmenu = document.querySelectorAll('.js-openSubmenu');
    const menuItemsBack = menuMobile.querySelectorAll('.js-goback');

    function openSubMenu(event) {
        event.preventDefault();

        if (event.target.closest('.parent-submenu') && event.target.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu')) {
            event.target.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu').classList.add('open');
        } else if (event.target.closest('.with-submenu') && event.target.closest('.with-submenu').querySelector('.sub-menu')) {
            event.target.closest('.with-submenu').querySelector('.sub-menu').classList.add('open');
        }
    }

    function closeSubMenu(event) {
        event.preventDefault();
        console.log('close');
        if (event.target.closest('.sub-menu')) {
            event.target.closest('.sub-menu').classList.remove('open');
        }
        return false;
    }

    if (ww < 992) {
        for (const menuItemLink of menuItemsOpenSubmenu) {
            if ((menuItemLink.closest('.with-submenu') && menuItemLink.closest('.menu-item') && menuItemLink.closest('.menu-item').classList.contains('with-submenu') && menuItemLink.closest('.with-submenu').querySelector('.sub-menu') !== null) || (menuItemLink.closest('.parent-submenu') && menuItemLink.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu') !== null)) {
                menuItemLink.closest('.menu-item-link').addEventListener('click', openSubMenu);
            }
        }

        for (const menuItemBack of menuItemsBack) {
            menuItemBack.addEventListener('click', closeSubMenu);
        }

        let itemmenus = document.querySelectorAll('.menu-item');
        for (const itemmenu of itemmenus) {
            if (!itemmenu.classList.contains('with-submenu')) {
                itemmenu.addEventListener('click', function (e) {
                    var target = e.target;
                    if (!target.classList.contains('js-goback')) {
                        itemmenu.querySelector('.menu-item-link a').click();
                    }
                });
            }
        }



    }
};
